import { afterNextRender, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ServerSentCommands } from '@common';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServerCommandService {
  commands$ = new Subject<keyof typeof ServerSentCommands>();

  private eventSource: EventSource | null = null;

  constructor() {
    afterNextRender(() => {
      this.eventSource = new EventSource(
        `${environment.baseUrl}/api/server-command`,
      );

      this.eventSource.onmessage = (event) => {
        const { data } = event;

        const { command } = JSON.parse(data);

        this.commands$.next(command as keyof typeof ServerSentCommands);
      };
    });
  }
}
